// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__290U4","overflowing":"ReadFullNote_overflowing__F98Eu"};